<template>
    <Header class="zc-header">
        <div class="logo">订单管理系统</div>
        <div class="navs">
            <div class="rx-breadcrumb">
                <Breadcrumb>
                    <BreadcrumbItem class="text-333"><Icon type="md-options"></Icon> {{$store.state.parentRouterName}}</BreadcrumbItem>
                    <BreadcrumbItem>{{$route.meta.title}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="nav nav-right">
                <span class="nav-todo">
                    <Dropdown class="todo-drop" placement="bottom-end" trigger="click" @on-visible-change="todoVisibleChange">
                        <a href="javascript:void(0)" class="todo-trigger">
                            <Badge :count="todo_total" :offset="[0,0]" :overflow-count="99">
                                <Icon type="ios-notifications-outline" size="24" />
                            </Badge>
                        </a>
                        <DropdownMenu slot="list">
                            <div class="todo-drop-title">我的待办事项</div>
                            <DropdownItem v-for="(item,index) in todo_list" :key="index" @click.native="goTodo(item)">
                                <span class="todo-item-title">{{ item.title }}</span>
                                <Badge :count="item.count" :overflow-count="999" class="todo-item-count" />
                            </DropdownItem>
                            <div class="todo-drop-empty text-999" v-if="todo_list.length <= 0">暂无待办事项</div>
                        </DropdownMenu>
                    </Dropdown>
                </span>
                <span class="nav-user">
                    <Poptip content="content" trigger="hover" placement="bottom-end">
                    <a href="javascript:void(0)">
                        <Icon type="ios-contact" size="18"/>
                        <span>{{ $store.state.userinfo.realName }} ( {{$store.state.userinfo.sex}} )</span>
                        <Icon type="ios-arrow-down" size="18"></Icon>
                    </a>
                    <div class="em-tip-tit" slot="title">
                        <div class="info">
                            <div class="name">{{ $store.state.userinfo.username }}</div>
                            <div class="position">&nbsp;{{ $store.state.userinfo.groupName }}</div>
                        </div>
                        <div class="avatar"><Icon type="ios-person-outline" size="30"/></div>
                    </div>
                    <div class="em-tip-content" slot="content">
                        <div class="line">
                            <Icon type="ios-medkit-outline" size="18" class="line-icon"/>
                            <span>账号安全</span>
                        </div>
                        <Divider class="em-divider"/>
                        <div class="logout" @click="loginOut">退出</div>
                    </div>
                </Poptip>
                </span>
            </div>
        </div>
    </Header>
</template>

<script>
export default {
    name: 'Headers',
    components: {

    },
    data () {
        return {
            todo_list: [],
            todo_total: 0,
        }
    },
    mounted(){
        this.getTodoList();
    },
    methods:{
        //待办事项
        getTodoList(){
            let that = this;
            that.$axios.get('/admin/todo/getList')
                .then(function (e) {
                    if(e.code == 0) {
                        that.todo_list = e.data.list || [];
                        that.todo_total = e.data.total || 0;
                    }
                })
                .catch(function (e) {});
        },
        //下拉展开时刷新
        todoVisibleChange(visible){
            if(visible) this.getTodoList();
        },
        goTodo(item){
            if(!item.url) return;
            this.$router.push({ path: item.url }).catch(function(){});
        },
        loginOut() {
            let that = this;
            this.$Modal.confirm({
                title: '退出',
                content: '您确定要退出吗?',
                onOk: () => {
                    that.$axios.get('/admin/login/logout')
                        .then(function (e) {
                            if(e.code == 0) {
                                that.$Message.success({ background: true,duration:3, content: e.msg});
                                that.$store.commit('SET_TOKEN' , '');
                                that.$store.commit('SET_USERINFO' , '');
                                that.$store.commit('SET_OPEN_NAMES' , 1);
                                that.$store.commit('SET_ACTIVE_NAMES' , 1);
                                that.$store.commit('SET_AUTH' , '');
                                that.$store.commit('SET_ROUTERS' , []);
                                that.$router.push({ path: '/login' })
                            }else{
                                that.$Message.error({ background: true,duration:3, content: e.data});
                            }
                        })
                        .catch(function (e) {
                            that.$Message.error({ background: true,duration:3, content: '退出失败'});
                        });
                },
                onCancel: () => {}
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
    .nav-right {
        display: flex;
        align-items: center;
        gap: 50px;
    }

  

    .todo-trigger {
        display: inline-block;
        line-height: 1;
        padding-top: 4px;
        //color: #fff;

        &:hover {
            color: #09f;
        }
    }

    .todo-drop-title {
        padding: 8px 16px;
        border-bottom: 1px solid #e8eaec;
        font-weight: bold;
        color: #333;
        line-height: 1.8 !important;
        color: #09f;
    }

    .todo-item-title {
        display: inline-block;
        min-width: 96px;
    }

    .todo-item-count {
        float: right;
        margin-top: 2px;
    }

    .todo-drop-empty {
        padding: 14px 16px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/public/Headers.vue